import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-sms',
  templateUrl: './sms-sms.component.html',
  styleUrls: ['./sms-sms.component.scss']
})
export class SmsSmsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
